export default __webpack_public_path__ + "static/media/link.2f5ab1c7.webp";